import { render, staticRenderFns } from "./SectionFileUploads.vue?vue&type=template&id=9bc9779e&scoped=true"
import script from "./SectionFileUploads.vue?vue&type=script&lang=js"
export * from "./SectionFileUploads.vue?vue&type=script&lang=js"
import style0 from "./SectionFileUploads.vue?vue&type=style&index=0&id=9bc9779e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc9779e",
  null
  
)

export default component.exports